import React, { ChangeEvent, useState } from 'react';
import { IconButton } from '@mui/material';
import { IconPassword } from '../../assets/icons';
import { InputMui } from '../input-mui/input-mui';

type InputPinProps = {
  value: string;
  name?: string;
  disabled?: boolean;
  label: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: string;
};

export const InputPin: React.FC<InputPinProps> = (props) => {
  const [showPin, setShowPin] = useState<boolean>(false);

  const toggleShowPin = (event: React.PointerEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setShowPin(!showPin);
  };

  return (
    <InputMui
      {...props}
      type={showPin ? 'text' : 'password'}
      endIcon={
        <IconButton onClick={toggleShowPin}>
          <IconPassword isOn={!showPin} />
        </IconButton>
      }
    />
  );
};
